import React from 'react'
import { Card, Accordion } from 'react-bootstrap';

/**
 * props:
link
links
*/
const ProjectLinks = (props) => {
    const LINKS_OUTSIDE_ACCORDION = 5
    return (
        <div>
            <div key="-1"><Card.Link href={props.link} target="_blank">website</Card.Link></div>
            {props.links &&
                <div>
                    <b>resources:</b>
                    {props.links.map((k, i) => {
                        if (i < LINKS_OUTSIDE_ACCORDION) {
                            const link = k.replace('http://', '').replace('https://', '');
                            return <div key={i}><Card.Link href={k} target="_blank"><span className='small'>{link.length > 80 ? `${link.substr(0, 60)}...` : link}</span></Card.Link></div>
                        }
                    })
                    }
                    {props.links.length > LINKS_OUTSIDE_ACCORDION &&
                        <Accordion defaultActiveKey="-1">
                            <Card style={{ border: "none" }}>
                                <Accordion.Toggle as={Card.Header} eventKey="0" style={{ border: "none", backgroundColor: "white", padding: "20px 0 0 0", cursor: "pointer" }}>
                                    More {props.links.length - LINKS_OUTSIDE_ACCORDION}...
                         </Accordion.Toggle>
                                <Accordion.Collapse eventKey="0">
                                    <Card.Body>
                                        {props.links.map((k, i) => {
                                            if (i >= LINKS_OUTSIDE_ACCORDION) {
                                                const link = k.replace('http://', '').replace('https://', '');
                                                return <div key={i}><Card.Link href={k} target="_blank"><span className='small'>{link.length > 80 ? `${link.substr(0, 60)}...` : link}</span></Card.Link></div>
                                            }
                                        })
                                        }
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    }

                </div>}
        </div>
    )
}

export default ProjectLinks